import React from 'react'
import ErrorBase from '../components/ErrorBase'
import { isRouteErrorResponse, useRouteError } from 'react-router';

export default function ErrorPage() {
    const error = useRouteError();

    console.error(error)

    if (isRouteErrorResponse(error)) {
        return <ErrorBase
            errorCode={error.status}
            src="/images/blinking.gif"
            errorDescription={<>
                <span>{error.statusText}</span>
                <code>{error.data}</code>
            </>}
            className='text-primary'
        />
    } else if (error instanceof Error) {
        return <ErrorBase
            errorCode={500}
            src="/images/blinking.gif"
            errorDescription={<>
                <span className='block text-sm'>{error.message}</span>
                <code className='overflow-x-auto absolute bottom-0 left-0 right-0 p-2 bg-slate-600 text-white text-xs'>{error.stack}</code>
            </>}
            className='text-primary'
        />
    } else {
        return <ErrorBase
            errorCode={500}
            src="/images/blinking.gif"
            errorDescription={<>
                <span>Application Error</span>
                <code>Unknown error</code>
            </>}
            className='text-primary'
        />
    }
}